import { LinkParagraph } from '@nexus/lib-react/dist/core/Link/LinkParagraph';
import { Paragraph3, Paragraph2 } from '@nexus/lib-react/dist/core/Typography';
import { Banner } from '@nexus/lib-react/dist/core/Banner/Banner';
import styled from '@olxeu-a2b/ui/src/theme/styled';

const Dac7BannerContainer = styled(Banner)`
  padding: 16px;

  & > div {
    width: 100%;

    & > p {
      width: 100%;
    }
  }
`;

const Dac7BannerLink = styled(LinkParagraph)`
  display: inline-block;
  width: 100%;
  text-align: right;
  font-weight: 500;
  margin-top: 14px;
`;

const Dac7BannerTitle = styled(Paragraph3)`
  margin-bottom: 4px;
  font-size: 14px;
  line-hight: 18px;
`;

const Dac7BannerText = styled(Paragraph2)`
  font-size: 14px;
  line-hight: 18px;
`;

export { Dac7BannerLink, Dac7BannerTitle, Dac7BannerText, Dac7BannerContainer };
